import React, { FunctionComponent } from 'react'
import { combineStatesComponentType } from './types'

export function combineStates<ComposedInputType = any, OwnPropsType = any, OutputPropsType = any, OuputEventsType = any>(
  Component: FunctionComponent<OutputPropsType & OuputEventsType>,
  mapProps: (ownProps: ComposedInputType & OwnPropsType) => OutputPropsType = (() => ({} as OutputPropsType)),
  mapEvents: (ownProps: ComposedInputType & OwnPropsType) => OuputEventsType = (() => ({} as OuputEventsType)),
  components: combineStatesComponentType[] = [],
): FunctionComponent<OwnPropsType> {
  const Comp: FunctionComponent<ComposedInputType & OwnPropsType> = (props: ComposedInputType & OwnPropsType) => {
    return <Component {...mapProps(props)} {...mapEvents(props)} />
  }
  return (ownProps: OwnPropsType) => {
    const ResultComponent = components.reduce<FunctionComponent<any>>((acc, WrapComponent) => {
      return WrapComponent(acc)
    }, Comp)
    return <ResultComponent {...ownProps} />
  }
}
